import carouselTransform from "./strategies/carousel";
import purchaseAttributesTransform from "./strategies/purchase-attributes";
import productSummaryTransform from "./strategies/product-summary";
import refinementCrumbsTransform from "./strategies/refinement-crumbs";
import skuTransform from "./strategies/skus";
import productEducationTransform from "./strategies/product-education";
import topLevelTransforms from "./strategies/top-level-transforms";
import colorAttributesTransform from "./strategies/color-attributes";

const legacyTransforms = [
  {
    field: "product-summary",
    gqlKey: "productSummary",
    fn: productSummaryTransform,
  },
  {
    field: "purchase-attributes",
    gqlKey: "root",
    fn: purchaseAttributesTransform,
  },
  {
    field: "refinement-crumbs",
    gqlKey: "refinementCrumbs",
    fn: refinementCrumbsTransform,
  },
  {
    field: "product-carousel",
    gqlKey: "productCarousel",
    fn: carouselTransform,
  },
  {
    field: "child-skus",
    gqlKey: "skus",
    fn: skuTransform,
  },
  {
    field: "productEducation",
    gqlKey: "colorAttributes",
    fn: productEducationTransform,
  },
  {
    field: "colorAttributes",
    gqlKey: "colorAttributes",
    fn: colorAttributesTransform,
  },
];

const TransformProductDataToLegacy = (productData = {}) => {
  const gql = productData ?? {};
  const transformedData = legacyTransforms.reduce(
    (prev, { field, fn, gqlKey } = {}) => {
      const gqlDataEquivalent = gqlKey === "root" ? gql : gql?.[gqlKey];
      const t = fn?.(gqlDataEquivalent);
      return {
        ...prev,
        [field]: t,
      };
    },
    {}
  );

  const otherTransforms = topLevelTransforms(gql);

  return {
    ...transformedData,
    ...otherTransforms,
  };
};

export default TransformProductDataToLegacy;
